import './index.css';
import simulatedsService from "../../../../services/simulateds.service";
import { useEffect, useState } from "react";
import { Image, Modal } from "react-bootstrap";
import getModuleIcon from "../../../../utils/getModuleIcon";

const QuestionsIncorretModal = (props) => {
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        const loadQuestionsIncorrect = async () => {
            let response = await simulatedsService.incorrect({
                'idSimulated': props.simulated.id
            });
            if (response.status === 'success') {
                setQuestions(response.data);
                props.isLoadingQuestionsIncorrect();
            }
        }

        if (props.simulated.incorrect > 0 && questions.length === 0) {
            loadQuestionsIncorrect();
        }
    }, [questions, props]);

    function isPlateQuestion(question) {
        return question.module?.title === 'Placas, Cores e Caminhos' && question.plate_code;
    }

    return (
        <Modal
            fullscreen="lg-down"
            onHide={props.onHide}
            show={props.show}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>Questões incorretas</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="questions-incorrect">
                    {
                        Object.keys(questions).map((key) => {
                            return (
                                <div key={key} className='question'>
                                    <div className='title'>{questions[key].question_text}
                                    {
                                        isPlateQuestion(questions[key]) && (
                                            <div className="image">
                                                <Image src={process.env.PUBLIC_URL + '/assets/plates/' + questions[key].plate_code + '.png'} thumbnail />
                                                <div className="code">
                                                    {questions[key].plate_code}
                                                </div>
                                            </div>
                                        )
                                    }
                                    </div>                                   
                                    <div className="module">
                                        {getModuleIcon(questions[key].module.title)}
                                        <span>
                                            {questions[key].module.title}
                                        </span>
                                    </div>
                                    {
                                        questions[key].answers.map((alternative, index) => (
                                            <div key={index} className='option'>
                                                {
                                                    alternative.id === questions[key].correctAnswerId && (
                                                        <div className='alternative-correct'>
                                                            <i>{String.fromCharCode(65 + index)}</i>
                                                            {alternative.answer_text}
                                                            <svg viewBox="0 0 33 23">
                                                                <path d="M11.4702 22.744L0.368164 12.0264L2.49936 9.96898L11.4702 18.6292L30.5023 0.256104L32.6335 2.31351L11.4702 22.744Z" fill="#41B26E"/>
                                                            </svg>
                                                        </div>
                                                    )
                                                }
                                                {
                                                    alternative.id === questions[key].selectedAnswerId && (
                                                        <div className='alternative-incorrect'>
                                                            <i>{String.fromCharCode(65 + index)}</i>
                                                            {alternative.answer_text}
                                                            <svg viewBox="0 0 29 29">
                                                                <path d="M2.70918 28.4344L0.56543 26.2907L12.3561 14.5L0.56543 2.70942L2.70918 0.565674L14.4998 12.3563L26.2904 0.565674L28.4342 2.70942L16.6436 14.5L28.4342 26.2907L26.2904 28.4344L14.4998 16.6438L2.70918 28.4344Z" />
                                                            </svg>
                                                        </div>
                                                    )
                                                }
                                                {
                                                    alternative.id !== questions[key].correctAnswerId && alternative.id !== questions[key].selectedAnswerId && (
                                                        <div className='alternative'>
                                                            <i>{String.fromCharCode(65 + index)}</i>
                                                            {alternative.answer_text}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        ))
                                    }
                                    <div className='comment'>
                                        <strong>Dica:</strong> {questions[key].comment_text}
                                    </div>
                                </div>
                            )
                        })
                    }
                    <div className="legend-container">
                        <div className="legend">
                            <i className="selected"></i>
                            <span>Resposta incorreta</span>
                        </div>
                        <div className="legend">
                            <i className="correct"></i>
                            <span>Resposta correta</span>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default QuestionsIncorretModal;
